import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { IMessageTypeListItem, MessageTypeListItem } from "./messageTypeListItem";

export interface IMessageTypeListItems extends ListItems<IMessageTypeListItem> {
}

export class MessageTypeListItems extends ListItems<MessageTypeListItem> implements IMessageTypeListItems {
    constructor();
    constructor(obj: IMessageTypeListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, MessageTypeListItem);
    }
}